import {Component, EventEmitter, Output, ViewContainerRef} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Configuration} from '../../shared/services/configuration';
import {HttpClientCustom} from '../../shared/services/http.client';
import * as _ from 'underscore';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Location} from '@angular/common';
import {SharedData} from '../../shared/sharedData';
import {Subject} from 'rxjs/Subject';
import {debounceTime} from 'rxjs/operator/debounceTime';
import {ToasterComponent} from '../../toasterComponent/toasterComponent';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'AddUserGroup',
  templateUrl: 'addUserGroup.html',
  inputs: ['parentOrg'],
})
export class AddUserGroupComponent {

  @Output() addOrgEvent = new EventEmitter();
  public _baseUrl: any;
  public orgTypeData: any = [];
  public currentEmployee: any;
  public type: any = 'ADD';
  public asl: boolean = false;
  public designationModel: any;
  public oldValue = null;
  public empPresent: boolean = false;
  data: any;

  public cancelEvent: any = new EventEmitter();
  //public addOrgEvent: any = new EventEmitter();
  public myData: any;
  public arrayOfStrings = [];
  public categoryData: any = [];
  public myForm: FormGroup;
  public previousSearchKey;
  public orgTypeModel: any;
  public _failure = new Subject<string>();
  public _success = new Subject<string>();
  errorMessage: string;
  successMessage: string;

  public warning: any = "Please type to select";



  // tslint:disable-next-line:member-ordering
  public payload = {
    searchString: "",
    excludeEmpIds: []
  };

  public parentOrg: any;
  public userGroupdata = {
    id: null,
    name: null,
    description: null,
    version: null,
    roleGroups: [],
    userGroups: [],
    userCount: null,
  };

  public errorMsg = {
    "USER_NAME_EXISTS": "User name already exists",
    "EMAIL_EXISTS": "Email id already exists",
    "EMPCODE_EXISTS": "Employee code already exists"
  };

  constructor(
    public route: ActivatedRoute,
    public modalService: NgbModal,
    public _global: Configuration,
    public http: HttpClientCustom,
    public _sanitizer: DomSanitizer,
    public builder: FormBuilder,
    public router: Router,
    public _location: Location,
    public share: SharedData,
    public translate:TranslateService,
    public _toaster: ToasterComponent,
    vcr: ViewContainerRef
  ) {
    this._baseUrl = _global.get("EPMS_BASE_URL");
    let data: any = this.share.getData();
    if (_.isEmpty(data)) {
      this._location.back();
    } else {
      if (data.type == "ADD") {
        this.data = {};
        this.type = "ADD";
      }
      else if (data.type == "EDIT") {
        
        this.userGroupdata = data.userGroup;
        this.type = "EDIT";
      }
      else {
        this.userGroupdata = data.userGroup;
        this.type = "DELETE";

        let url = this._baseUrl + 'v1/webAdmin/designation/check/' + this.userGroupdata.id;
        this.http.get(url).subscribe((result) => {
          if (result.success) {
            this.empPresent = true;
          } else {
            this.empPresent = false;
          }
        });
      }
    }

    this._toaster.setViewRef(vcr);
  }


  //when auto-complete value is selected this method fires and payload create
  gotNewValue(e, type) {
    setTimeout(() => { this.changeOldValue() }, 1000);
    
    if (type == 'designation') {


    }


  }

  public changeOldValue() {
    let self = this;
    self.oldValue = null;
  }

  ngOnInit(): void {
    this._failure.subscribe((message) => this.errorMessage = message);
    debounceTime.call(this._failure, 5000).subscribe(() => this.errorMessage = null);
    this._success.subscribe((message) => this.successMessage = message);
    debounceTime.call(this._success, 5000).subscribe(() => this.successMessage = null);
  }

  //to get list of Organization based on keyword
  orgTypeObservableSource = (keyword: any): Observable<any[]> => {
    try {
      let url = this._baseUrl + "v1/webAdmin/orgUnitType/autoComplete";
      url += '?name=' + keyword;
      if (keyword) {
        return this.http.get(url)
          .map((res) => {
            let json = res.data;
            return json;
          });
      } else {
        return Observable.of([]);
      }
    } catch (e) { console.log('catch orgUnitType Error') }

  }

  //Formatter
  nameValueFormatter(data: any): string {
    return `${data.name}`
  }
  typeValueFormatter(data: any): string {
    return `${data.type}`
  }
  orgNameValueFormatter(data: any): string {
    return `${data.orgName}`
  }
  autoCompleteListFormatter = (data: any): SafeHtml => {
    
    let html = `<span>${data.displayName}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }
  autoCompleteListFormatterType = (data: any): SafeHtml => {
    let html = `<span>${data.type}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }
  autoCompleteListGradeFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.name}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }
  autoCompleteListOrgFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.orgName}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }




  //to get list of designation based on keyword
  designationObservableSource = (keyword: any): Observable<any[]> => {
    try {
      let url = this._baseUrl + "v1/webAdmin/designation/designationSearch";
      url += "?searchString=" + keyword + "&id=" + this.userGroupdata.id;
      if (keyword.trim()) {
        return this.http.get(url)
          .map(res => {
            let json = res;
            return json;
          })
      } else {
        return Observable.of([]);
      }
    } catch (e) { }
  }



  autoCompleteListOrgTypeFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.orgUnitTypeName}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }


  //navigate back
  goToBackPage() {
    this._location.back();
  }


  editOrSave() {

    
    if (this.userGroupdata.name == null || this.userGroupdata.name == "") {
      this.translate.get('pleaseEnterNameToContinue').subscribe((msg)=>{
        this._toaster.showError(msg);
      });
     
      return false;
    }

    delete this.userGroupdata.userCount;

    if (this.type == "ADD") {
      let url = this._baseUrl + 'v1/hub/userGroup/save';
      this.http.post(url, this.userGroupdata).subscribe((result) => {
        if (result.success) {
          this.translate.get('userGroupSaved').subscribe((msg)=>{
            this._toaster.showSuccess(msg);
          });
          setTimeout(() => this.goToBackPage(), 1000);
        } else {
          this.translate.get('userGroupSaved').subscribe((msg)=>{
            this._toaster.showError(msg);
          });
          for (let val of result.errorMessages) {
            this._toaster.showError(val);
          }
        }
      });
    }
    if (this.type == "EDIT") {
      let url = this._baseUrl + 'v1/hub/userGroup/' + this.userGroupdata.id;
      this.http.put(url, this.userGroupdata).subscribe((result) => {
        if (result.success) {
          this.translate.get('userGroupUpdatedSuccessfully').subscribe((msg)=>{
            this._toaster.showSuccess(msg);
            setTimeout(() => this.goToBackPage(), 1000);
          })
       
        } else {
          this.translate.get('userGroupSaved').subscribe((msg)=>{
            this._toaster.showError(msg);
          });
          for (let val of result.errorMessages) {
            this._toaster.showError(val);
          }
        }
      });
    }
  }

  public closeinputs() {
    this.cancelEvent.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/tools/userGroup/addUserGroup.ts